import 'vant/lib/index.css';
import Vue from 'vue';
import {
  Button,
  DropdownMenu,
  DropdownItem,
  Cell,
  Switch,
  Field,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Tag
} from 'vant';

const components = [
  ['van-field', Field],
  ['van-button', Button],
  ['van-dropdown-menu', DropdownMenu],
  ['van-dropdown-item', DropdownItem],
  ['van-cell', Cell],
  ['van-switch', Switch],
  ['van-checkbox-group', CheckboxGroup],
  ['van-checkbox', Checkbox],
  ['van-radio-group', RadioGroup],
  ['van-radio', Radio],
  ['van-tab', Tab],
  ['van-tabs', Tabs],
  ['van-tabbar', Tabbar],
  ['van-tabbar-item', TabbarItem],
  ['van-nav-bar', NavBar],
  ['van-icon', Icon],
  ['van-tag', Tag]
];

export default function registerVant() {
  components.forEach(([name, component]) => {
    Vue.component(name, component);
  });
}
